var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBlockTopRight(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 94,
    height: 63,
    viewBox: "0 0 94 63",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_80_4487)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M23.8879 36.4924V27.7529H32.6523V36.4924H23.8879Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4738 45.2336V36.4941H85.2383V45.2336H76.4738Z",
    fill: "#FCE784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2394 36.4944V27.7549H94.0039V36.4944H85.2394Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.8879 45.2336V36.4941H32.6523V45.2336H23.8879Z",
    fill: "#FCE784"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9464 53.9729V45.2334H67.7109V53.9729H58.9464Z",
    fill: "#FBE683"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9464 62.7121V53.9727H67.7109V62.7121H58.9464Z",
    fill: "#95C8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36051 53.9729V45.2334H15.125V53.9729H6.36051Z",
    fill: "#FDF2BB"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9464 45.2336V36.4941H67.7109V45.2336H58.9464Z",
    fill: "#95C8BF"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M58.9464 36.4924V27.7529H67.7109V36.4924H58.9464Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4738 27.7531V19.0137H85.2383V27.7531H76.4738Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.36051 36.4924V27.7529H15.125V36.4924H6.36051Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4152 53.9729V45.2334H50.1797V53.9729H41.4152Z",
    fill: "#486D97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4152 62.7121V53.9727H50.1797V62.7121H41.4152Z",
    fill: "#486D97"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.4152 36.4924V27.7529H50.1797V36.4924H41.4152Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2394 53.9729V45.2334H94.0039V53.9729H85.2394Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4738 62.7121V53.9727H85.2383V62.7121H76.4738Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6535 53.9729V45.2334H41.418V53.9729H32.6535Z",
    fill: "#228696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6535 62.7121V53.9727H41.418V62.7121H32.6535Z",
    fill: "#228696"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M32.6535 45.2336V36.4941H41.418V45.2336H32.6535Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1222 45.2336V36.4941H23.8867V45.2336H15.1222Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7121 53.9729V45.2334H76.4766V53.9729H67.7121Z",
    fill: "#9A2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7121 62.7121V53.9727H76.4766V62.7121H67.7121Z",
    fill: "#DDA4A2"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7121 45.2336V36.4941H76.4766V45.2336H67.7121Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M67.7121 14.1028V5.36328H76.4766V14.1028H67.7121Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1222 53.9729V45.2334H23.8867V53.9729H15.1222Z",
    fill: "#9A2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.1222 62.7121V53.9727H23.8867V62.7121H15.1222Z",
    fill: "#9A2222"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1808 53.9729V45.2334H58.9453V53.9729H50.1808Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1808 62.7121V53.9727H58.9453V62.7121H50.1808Z",
    fill: "#218595"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M-2.40512 53.9729V45.2334H6.35938V53.9729H-2.40512Z",
    fill: "#245864"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1808 45.2336V36.4941H58.9453V45.2336H50.1808Z",
    fill: "#F5D858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M76.4738 36.4924V27.7529H85.2383V36.4924H76.4738Z",
    fill: "#F5D858"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M50.1808 27.7551V19.0156H58.9453V27.7551H50.1808Z",
    fill: "#B43125"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2394 45.2336V36.4941H94.0039V45.2336H85.2394Z",
    fill: "#8DA9C9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M85.2394 8.73948V0H94.0039V8.73948H85.2394Z",
    fill: "#8DA9C9"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_80_4487"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 94,
    height: 63,
    fill: "white",
    transform: "matrix(-1 0 0 1 94 0)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBlockTopRight);
export default __webpack_public_path__ + "static/media/block-top-right.73a6fccd6cd1beb54e8ac05f82967aab.svg";
export { ForwardRef as ReactComponent };